import { createSelector } from 'reselect'

export const getPackages = createSelector(
  state => state && state.user && state.user.packages && Array.isArray(state.user.packages.items)
    ? state.user.packages.items.filter(item => item.visible) : [],
  items => items
)
